<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      Nova vest
    </div>
    <div class="inputs">
      <span>naslov:</span>
      <input class="single-input" type="text" v-model="new_title" />
    </div>
    <div class="inputs">
      <span>tekst:</span>
      <textarea
        rows="10"
        class="single-input"
        type="text"
        v-model="new_article"
      ></textarea>
    </div>
    <div class="inputs">
      <span>autor:</span>
      <input
        maxlength="100"
        class="single-input"
        type="text"
        v-model="new_author"
      />
    </div>
    <div class="inputs" style="margin-bottom: 30px;">
      <span>links:</span>
      <div v-for="(link, index) in links" :key="index" class="flex">
        <input
          maxlength="100"
          class="single-input"
          type="text"
          placeholder="tekst"
          v-model="link.text"
        />
        <input
          maxlength="100"
          class="single-input"
          type="text"
          placeholder="link"
          v-model="link.link"
        />
        <div
          v-if="links.length > 1"
          @click="deleteLink(index)"
          class="icon-wrapper"
        >
          <img title="Obriši" src="@/assets/icons/trash.png" alt="trash icon" />
        </div>
      </div>

      <button v-if="links.length < 5" @click="addNewLink">
        dodaj link
      </button>
    </div>
    <div class="inputs">
      <span>slika:</span>
      <input
        @change="setImage($event.target.files[0])"
        ref="imginput"
        class="single-input"
        type="file"
        accept=".png, .jpg, .jpeg"
      />
      <span>Slika mora biti manja od 500kb</span>
    </div>
    <div class="btn-wrapper">
      <div @click="ok()" class="btn">
        Kreiraj
      </div>
      <div @click="closeModal()" class="btn alt">
        Odustani
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
export default {
  name: "editDocument",
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      new_title: null,
      new_article: null,
      new_author: null,
      new_image: null,
      links: [{ link: "", text: "" }]
    };
  },
  methods: {
    addNewLink() {
      if (this.links.length >= 5) return;
      this.links.push({ link: "", text: "" });
    },
    deleteLink(index) {
      if (this.links.length <= 1) return;
      this.links.splice(index, 1);
    },
    checkLinks() {
      let sendLinks = [];
      for (let i = 0; i < this.links.length; i++) {
        console.log(this.links[i].link);
        if (this.links[i].link.length > 0) {
          sendLinks.push(this.links[i]);
        }
      }
      return sendLinks.length > 0 ? sendLinks : undefined;
    },
    ok() {
      if (
        this.new_title &&
        this.new_title !== "" &&
        this.new_article &&
        this.new_article !== "" &&
        this.new_author &&
        this.new_author !== "" &&
        this.new_image
      ) {
        let params = new FormData();
        params.append("new_title", this.new_title);
        params.append("new_article", this.new_article);
        params.append("new_author", this.new_author);
        params.append("new_image", this.new_image);

        let links = this.checkLinks();
        // if (links) params.append("links", links);

        this.modalData.ok(params, links);
        eventBus.$emit("closeModal");
      } else {
        this.$toast.error("Morate popuniti sva polja i izabrati sliku!", {
          duration: 8000
        });
      }
    },
    closeModal() {
      eventBus.$emit("closeModal");
    },
    setImage(image) {
      if (image.size > 500000) {
        this.$refs.imginput.value = null;
        this.$toast.error(this.$t("details.details.imageSizeErrorNews"), {
          duration: 8000
        });
      } else {
        this.new_image = image;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 90%;
  max-width: 80%;
  max-height: 80vh;
  padding-bottom: 30px !important;
  overflow: auto !important;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 10px 0px;
    }
    textarea {
      width: 100%;
    }
  }
  .flex {
    display: flex;
    align-items: center;
    gap: 5px;
    img {
      cursor: pointer;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      min-width: 100px;
      border-radius: 10px;
    }
  }
}
</style>
